import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SliderService } from '../../services/slider.service';
import { environment } from '../../../../environments/environment';
import { ImgViewComponent } from '../img-view/img-view.component';

interface SliderItem {
  id: number;
  title: string;
  content: string;
  imageUrl: string;
  selectedFileBase64: string | null;
  text1?: string;
  text2?: string;
  link1?: string;
  link2?: string;
}

@Component({
  selector: 'app-home-slider',
  templateUrl: './home-slider.component.html',
  styleUrls: ['./home-slider.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, CarouselModule, ImgViewComponent]
})
export class HomeSliderComponent implements OnInit {
  sliders: SliderItem[] = [];
  apiUrl = environment.apiUrl.slice(0, -4);

  owlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    items: 1,
    nav: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    smartSpeed: 1000,
    margin: 0,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 }
    }
  };

  constructor(private sliderService: SliderService) { }

  ngOnInit(): void {
    // SSR için slider verilerini hemen yükle
    this.getSliders();
  }

  async getSliders(): Promise<void> {
    try {
      const sliders = await this.sliderService.getSliders();
      this.sliders = sliders.map(slider => ({
        ...slider,
          imageUrl: slider.imageUrl
      }));
    } catch (error) {
      // console.error('Slider verilerini getirirken hata oluştu:', error);
    }
  }
}

